export default [
  {
    path: '/ticket_checking',
    name: 'TicketCheckingRecord',
    component: () =>
      import(
        /* webpackChunkName: "ticket" */ '@/projects/operation/views/Ticket/TicketCheckingRecord.vue'
      )
  },
  {
    path: '/ticket_sell',
    name: 'TicketSellRecord',
    component: () =>
      import(
        /* webpackChunkName: "ticket" */ '@/projects/operation/views/Ticket/TicketSellRecord.vue'
      )
  },
  {
    path: '/event_mgmt',
    name: 'EventManagement',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './ShowManagement.vue')
  },
  {
    path: '/session_mgmt',
    name: 'SessionManagement',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './SessionManagement.vue')
  },
  {
    path: '/hall_mgmt',
    name: 'HallManagement',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './HallManagement.vue')
  },
  {
    path: '/boxoffice',
    name: 'BoxOfficeStatistics',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './BoxOfficeStatistics.vue')
  }
]
